module.exports = __webpack_public_path__ + "img/specialthanks.98ff9b73.png";